// textes-auto-labels.js — table UNIQUE des libellés affichés sur l'écran
// Voyageurs › Textes automatiques (Plateformes, Direct, SMS).
//
// AFFICHAGE SEUL : chaque table traduit une valeur BRUTE stockée (canal,
// trigger_type, statut d'envoi…) en mots de tous les jours. Les valeurs
// stockées, les conditions d'envoi et le moteur ne lisent JAMAIS ce fichier —
// le changer ne modifie aucun envoi. Une valeur absente de la table retombe
// sur un libellé neutre ou sur la valeur brute (selon le helper), jamais sur
// une erreur.

// Canal d'un envoi — libellé COMPLET (choix du canal, modification rapide).
// Mots du menu des canaux de la maquette validée v677 (Voyageurs ›
// Automatisations) : « Messagerie de la réservation », « Courriel à l'équipe ».
// Le courriel garde « Courriel » : la maquette dit « Courriel (direct) » parce
// que, chez elle, ce canal sert aux réservations directes ; dans le volet
// Plateformes de l'app il écrit au voyageur Airbnb / Booking, « (direct) »
// serait faux.
export const CANAL_LABELS = {
  email: "Courriel",
  tchat_ota: "Messagerie de la réservation",
  notif_interne: "Courriel à l'équipe",
  webpush: "Notification sur téléphone — pas disponible",
  whatsapp: "WhatsApp",
  sms: "SMS",
};

// Canal — libellé COURT (pastilles, colonnes étroites).
export const CANAL_SHORT_LABELS = {
  email: "Courriel",
  tchat_ota: "Messagerie de la réservation",
  notif_interne: "Équipe",
  webpush: "Notification sur téléphone",
  whatsapp: "WhatsApp",
  sms: "SMS",
};

// Canal — forme insérée dans la phrase-résumé « Envoyé … par {canal}, … ».
export const CANAL_SENTENCE_LABELS = {
  email: "courriel",
  tchat_ota: "la messagerie de la plateforme",
  notif_interne: "courriel à l'équipe",
  whatsapp: "WhatsApp",
  webpush: "notification sur téléphone",
  sms: "SMS",
};

export function canalLabel(canal) {
  return CANAL_LABELS[canal] || canal || "";
}
export function canalShortLabel(canal) {
  return CANAL_SHORT_LABELS[canal] || canal || "";
}
export function canalSentenceLabel(canal) {
  return CANAL_SENTENCE_LABELS[canal] || canal || "";
}

// Déclencheur non reconnu par l'écran (badge horaire de la liste).
export const UNKNOWN_TRIGGER_LABEL = "moment inconnu";

// Condition dont le champ n'a pas de libellé (résumé d'une carte d'envoi).
export const UNKNOWN_CONDITION_LABEL = "une condition particulière";

// Statut d'un envoi (colonne `message_logs.status`, journal du volet SMS).
// Valeurs de la contrainte message_logs_status_check. Les nombreux motifs
// `skipped_*` sont regroupés sous « Non envoyé » avec leur raison quand elle
// est dicible ; un statut inconnu retombe sur « Non envoyé » s'il commence par
// `skipped_`, sinon s'affiche tel quel.
export const SEND_STATUS_LABELS = {
  sent: "Envoyé",
  sent_dry_run: "Simulé (essai sans envoi)",
  failed: "Échec",
  skipped_sms_no_consent: "Non envoyé — pas d'accord du voyageur",
  skipped_channel_disabled: "Non envoyé — SMS coupés",
  skipped_marketing_optout: "Non envoyé — le voyageur a refusé les promotions",
  skipped_destinataire_missing: "Non envoyé — pas de numéro",
  skipped_idempotent: "Non envoyé — déjà envoyé",
  skipped_conditions_not_met: "Non envoyé — conditions non remplies",
  skipped_missing_vars: "Non envoyé — infos manquantes",
};

export function sendStatusLabel(status) {
  if (!status) return "";
  if (SEND_STATUS_LABELS[status]) return SEND_STATUS_LABELS[status];
  if (String(status).startsWith("skipped_")) return "Non envoyé";
  return status;
}
